import { useForm } from 'react-hook-form';
import { CallOtp, VerifyOtp } from '../../../resources/payload';
import { useCallOtp } from './useCallOtp';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useVerifyOtp } from './useVerifyOtp';

export const useGetEnterTelList = () => {
  const { control, getValues, setValue, handleSubmit, onFetch } = useForm();
  const { mutate: onSubmitCallOtp, loading: isLoadingCallOtp } = useCallOtp({
    onSuccessCallBack: onFetch,
  });
  const { mutate: onSubmitVerifyOtp, loading: isLoadingVerifyOtp } = useVerifyOtp({
    onSuccessCallBack: onFetch,
  });
  const [isSubmit, setIsSubmit] = useState(false);
  const [otpResponse, setOtpResponse] = useState({});
  const userId = useSelector((state) => state.line.profile.userId);
  const displayName = useSelector((state) => state.line.profile.displayName);

  const onSubmitTel = (values) => {
    const payload = CallOtp(values);
    onSubmitCallOtp(payload, {
      onSuccess: (response) => {
        if (response && response.item?.otpRef) {
          setOtpResponse(response);
          setValue('otpRef', response.item?.otpRef);
          setValue('lineUid', userId);
          setValue('lineName', displayName);
        }
        if (!isSubmit) {
          setIsSubmit(true);
        }
      },
    });
  };
  const onSubmitOtp = (values) => {
    const payload = VerifyOtp({
      ...values,
      otpRef: getValues('otpRef'),
      lineUid: getValues('lineUid'),
      lineName: getValues('lineName'),
    });
    onSubmitVerifyOtp(payload);
  };
  return {
    control,
    getValues,
    setValue,
    onSubmitTel,
    handleSubmit,
    isSubmit,
    otpResponse,
    onSubmitOtp,
    isLoadingCallOtp,
    isLoadingVerifyOtp,
  };
};
